import './PickerCombobox.scss';
import Skeleton from '@srm/ui/skeleton';

/** Строки-заглушки списка, пока нет первого ответа; `avatar` — строки адресной книги (с кругом, выше). */
const PickerSkeleton = ({ avatar = false }: { avatar?: boolean }) => (
    <div aria-hidden="true">
        {[64, 48, 56].map((width) => (
            <div
                key={width}
                className={
                    avatar
                        ? 'rf-picker-combobox__skeleton-row rf-picker-combobox__skeleton-row--avatar'
                        : 'rf-picker-combobox__skeleton-row'
                }
            >
                {avatar && <Skeleton circle height={32} />}
                <Skeleton height={12} width={`${width}%`} radius="sm" />
            </div>
        ))}
    </div>
);

export default PickerSkeleton;
